module.exports = __webpack_public_path__ + "img/logo4.1a5d8e3d.png";